import CaretDownOutlined from '@ant-design/icons/CaretDownOutlined';
import { isMobile } from '@vindr/utils/mobile';
import { Button } from 'antd';
import { ItemType } from 'antd/es/menu/hooks/useItems';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dropdown from './Dropdown';
import Icon from './Icon';
import Tooltip from './Tooltip';

const SplitButton = ({
  isRadio,
  isAction,
  //
  bState,
  //
  groupId,
  primary: _primary,
  secondary,
  items: _items,
  renderer,
  onInteraction,
}) => {
  const { t } = useTranslation('ViewerTool');

  const { primaryToolId, toggles } = bState;

  const handleSelectItem = (item) => {
    let foundItem;
    for (const it of _items) {
      if (it?.id === item?.props?.id) {
        foundItem = it;
        break;
      } else if (it?.items) {
        foundItem = it?.items.find((i) => i?.id === item?.props?.id);
        if (foundItem) break;
      }
    }
    if (foundItem) {
      onInteraction({
        groupId,
        //
        itemId: foundItem.id,
        interactionType: foundItem.type,
        // splitButtonId? (so we can track group?)
        // info to fire item's command/event?
        commands: foundItem.commands,
      });
      if (!foundItem?.isAction) {
        setState((state) => ({
          ...state,
          primary: { ...foundItem },
          isExpanded: false,
          items: getSplitButtonItems(_items).filter(
            (it) => it.id !== foundItem?.id
          ),
        }));
      }
    } else {
      console.warn('Menu not found');
    }
  };

  const getSplitButtonItems = (items) =>
    items.map((item, index) => ({
      ...item,
      key: item.id,
      index,
    }));

  const [state, setState] = useState({
    primary: _primary,
    items: getSplitButtonItems(_items).filter((item) =>
      isRadio && !isAction ? item.id !== _primary.id : true
    ),
    isHovering: false,
    isExpanded: false,
  });

  const onPrimaryClickHandler = () => {
    onInteraction({
      groupId,
      itemId: state.primary.id,
      interactionType: state.primary.type,
      // splitButtonId? (so we can track group?)
      // info to fire item's command/event?
      //
      commands: state.primary.commands,
    });
  };

  const isPrimaryActive =
    (state.primary.type === 'tool' && primaryToolId === state.primary.id) ||
    (state.primary.type === 'toggle' && toggles[state.primary.id] === true);

  const menuItems: ItemType[] = state.items.map((it) => ({
    ...it,
    icon: <Icon name={it.icon} className="text-4xl" />,
    label: t(it.label, { keySeparator: '>', nsSeparator: '|' }),
    children: it?.items || null,
    className: 'text-white text-base h-8 hover:text-primary-light',
  }));

  return (
    <div className="relative mx-1.5 flex">
      <Tooltip
        title={!isMobile() ? t(state.primary.tooltip) : ''}
        placement="bottom"
      >
        <Button
          type="link"
          onClick={onPrimaryClickHandler}
          className={`h-6 rounded-sm p-0 outline-none `}
        >
          <Icon
            name={state.primary.icon}
            className={`text-4xl hover:text-primary-light ${
              isPrimaryActive ? 'text-primary-light' : 'text-white'
            }`}
          />
        </Button>
      </Tooltip>
      <Dropdown
        menu={{
          items: menuItems,
          onClick: ({ item }) => {
            handleSelectItem(item);
          },
          className:
            'bg-background-light-3 dark:bg-background-dark-3 text-white hover:text-primary-light rounded-sm',
        }}
        trigger={['click']}
        className="align-center flex w-auto justify-center"
      >
        <Button type="link" className="flex h-6 items-center p-0">
          <CaretDownOutlined className="text-sm text-white hover:text-primary-light" />
        </Button>
      </Dropdown>
    </div>
  );
};

SplitButton.defaultProps = {
  isRadio: false,
  isAction: false,
  primary: {
    label: null,
    tooltip: null,
  },
  secondary: {
    icon: 'chevron-down',
    label: null,
    isActive: true,
    tooltip: 'More Measure Tools',
  },
  items: [],
};

SplitButton.propTypes = {
  primary: PropTypes.shape({
    id: PropTypes.string.isRequired,
    icon: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.oneOf(['tool', 'action', 'toggle']).isRequired,
    tooltip: PropTypes.string,
  }),
  secondary: PropTypes.shape({
    id: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string,
    tooltip: PropTypes.string,
    isActive: PropTypes.bool,
  }),
  renderer: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      icon: PropTypes.string,
      label: PropTypes.string,
      type: PropTypes.oneOf(['tool', 'action', 'toggle']).isRequired,
      tooltip: PropTypes.string,
      isActive: PropTypes.bool,
    })
  ),
  /** Callback function to inform ToolBarService of important events */
  onInteraction: PropTypes.func.isRequired,
};

export default SplitButton;
